import { APPEALS_ACTIONS } from "./actionTypes";
export const AppealsStateSelectors = {
  create: state => state.products[APPEALS_ACTIONS.CREATE]
};